import { useState } from 'react'
import { DashboardLayout } from '@/components/layout/DashboardLayout'
import { PjAgradaDetailModal } from '@/components/PjAgrada/PjAgradaDetailModal'
import { PjAgradaFormModal } from '@/components/PjAgrada/PjAgradaFormModal'
import { PjAgradaInviteModal } from '@/components/PjAgrada/PjAgradaInviteModal'
import { PjAgradaStatsCards } from '@/components/PjAgrada/PjAgradaStatsCards'
import { PjAgradaTable } from '@/components/PjAgrada/PjAgradaTable'
import { PjAgradaTopbar } from '@/components/PjAgrada/PjAgradaTopbar'
import { usePjAgradaPage } from '@/hooks/usePjAgradaPage'
import { useAuthStore } from '@/stores/authStore'

export default function PjAgradaPage() {
  const role = (useAuthStore((s) => s.user?.role) ?? '').toLowerCase()
  const canWrite = ['admin', 'financeiro'].includes(role)
  const canDelete = role === 'admin'
  const [showInviteModal, setShowInviteModal] = useState(false)

  const {
    prestadores,
    stats,
    loading,
    search,
    setSearch,
    filter,
    setFilter,
    showFormModal,
    setShowFormModal,
    formData,
    setFormData,
    saving,
    selected,
    setSelected,
    reload,
    openForm,
    handleSave,
    handleDelete,
  } = usePjAgradaPage()

  return (
    <DashboardLayout title='Funcionários PJ Agrada'>
      <div className='space-y-4'>
        <header>
          <h2 className='text-xl font-semibold text-text-primary'>Colaboradores PJ</h2>
          <p className='mt-2 max-w-3xl text-sm leading-relaxed text-text-muted'>
            Cadastro, documentos, dados bancários e links de auto-preenchimento dos profissionais PJ
            da Agrada.
          </p>
        </header>

        <PjAgradaTopbar
          filter={filter}
          setFilter={setFilter}
          search={search}
          setSearch={setSearch}
          loading={loading}
          onReload={() => void reload()}
          canWrite={canWrite}
          onNew={() => openForm()}
          onInvite={canWrite ? () => setShowInviteModal(true) : undefined}
        />

        {!loading && <PjAgradaStatsCards stats={stats} />}

        <PjAgradaTable
          prestadores={prestadores}
          loading={loading}
          search={search}
          onSelect={setSelected}
          onEdit={canWrite ? openForm : undefined}
          onDelete={canDelete ? handleDelete : undefined}
          onInvite={canWrite ? () => setShowInviteModal(true) : undefined}
        />
      </div>

      <PjAgradaInviteModal
        open={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        onGenerated={() => void reload()}
      />

      <PjAgradaFormModal
        open={showFormModal}
        onClose={() => setShowFormModal(false)}
        formData={formData}
        setFormData={setFormData}
        onSave={handleSave}
        saving={saving}
      />

      <PjAgradaDetailModal
        prestador={selected}
        onClose={() => setSelected(null)}
        onEdit={
          canWrite
            ? (pj) => {
                setSelected(null)
                openForm(pj)
              }
            : undefined
        }
      />
    </DashboardLayout>
  )
}
